import { Entity, IEntity } from "./Entity";

export interface IRiskAppIncidentStakeholder extends IEntity {
    StakeholderID?: number;
    IncidentID?: number;
}

export class RiskAppIncidentStakeholder extends Entity implements IRiskAppIncidentStakeholder {
    public StakeholderID = null;
    public IncidentID = null;
}